import type { TypographyProps } from '@iheartjane/reefer';
import { Typography } from '@iheartjane/reefer';

export const MaxCharacterHelper = ({
  maxLength,
  value,
  ...props
}: {
  maxLength?: number;
  value: string;
} & TypographyProps) => {
  if (!maxLength) return null;

  return (
    <Typography
      //  Render as span so we dont have a <div> or <p> nested inside an existing <p> tag
      as="span"
      color={value.length >= maxLength ? 'error' : 'grays-mid'}
      // Render as inline block to honor margin + padding while also being a span
      style={{ display: 'inline-block' }}
      {...props}
    >
      {value.length}/{maxLength} characters
    </Typography>
  );
};
